<template>
	<div class="" style="width:99vw;overflow: hidden;">
		<!-- <alienSwiper /> -->
		<homeTopSwiper style="width: 100%;height: 80vh;" />
		<div class="flexCol alit">
			<div class="title">广积粮ICA大数据平台</div>
			<div class="flex alit justc" style="width: 100%;">
				<div class="flexCol alit cp" :class="cpIndex == 1 ? 'cp-check' : 'cp'" @mouseover="cpIndex = 1">
					<img src="../assets/icon-big-data_.png" style="width:70px;" alt="" />
					<div class="">提高生产力</div>
				</div>
				<div class="flexCol alit cp" :class="cpIndex == 2 ? 'cp-check' : 'cp'" @mouseover="cpIndex = 2">
					<img src="../assets/icon-big-data_.png" style="width: 70px;" alt="" />
					<div class="">拓展市场渠道</div>
				</div>
				<div class="flexCol alit cp" :class="cpIndex == 3 ? 'cp-check' : 'cp'" @mouseover="cpIndex = 3">
					<img src="../assets/icon-big-data_.png" style="width: 70px;" alt="" />
					<div class="">提升品牌价值</div>
				</div>
				<div class="flexCol alit cp" :class="cpIndex == 4 ? 'cp-check' : 'cp'" @mouseover="cpIndex = 4">
					<img src="../assets/icon-big-data_.png" style="width: 70px;" alt="" />
					<div class="">形成数据资产</div>
				</div>
			</div>
			<div class="flex alit" v-if="cpIndex == 1"
				style="width: 70vw;font-size: 36px;margin: 30px 0;border: 1px solid #dedede;border-radius: 10px;padding: 10px;">
				<img style="width: 20vw;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81/%E5%8D%83%E5%B9%BF%E6%99%BA%E5%86%9C.png" alt="" />
				<div class="flexCol alit justc" style="flex: 1;">
					<div class="">Data + ICA</div>
					<div class="" style="margin-top: 20px;">农业大数据资源+模型与人工智能算法=智慧种植决策</div>
				</div>
			</div>
			<div class="flex alit" v-if="cpIndex == 2"
				style="width: 70vw;font-size: 28px;margin: 30px 0;border: 1px solid #dedede;border-radius: 10px;padding: 10px;">
				<img style="width: 35vw;margin-right: 10px;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81/%E6%8B%93%E5%B1%95%E6%B8%A0%E9%81%93.png" alt="" />
				<div class="flexCol alit justc" style="flex: 1;">
					<div class="" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以重庆市政府《推进火锅产业高质量发展的意见》为指导，千广与市政府同共打造重庆火锅产业要素交易平台:整合重庆3600亿产值的火锅产业和4万家火锅门店800亿营收，构建火锅产业总部经济和食材交易中心，为全球200多个城市和全国50万家火锅门店提供高品质食材一站式供应服务，解决区域农产品实现源头直供火锅企业的销售难题，协助地方政府构建产业闭环，实现产业振兴带动乡村振兴。</div>
				</div>
			</div>
			<div class="flex alit" v-if="cpIndex == 3"
				style="width: 70vw;font-size: 33px;margin: 30px 0;border: 1px solid #dedede;border-radius: 10px;padding: 10px;">
				<img style="width: 25vw;height: auto;margin-right: 10px;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81/%E5%93%81%E7%89%8C%E6%8F%90%E5%8D%87.png" alt="" />
				<div class="flexCol alit justc" style="flex: 1;">
					<div class="" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在数字化领域通过技术、数据、运营、咨询为客户提供品牌保披、渠道管控、营销全价值链产品及服务!</div>
				</div>
			</div>
			<div class="flex alit" v-if="cpIndex == 4"
				style="width: 70vw;font-size: 33px;margin: 30px 0;border: 1px solid #dedede;border-radius: 10px;padding: 10px;">
				<img style="width: 30vw;height: auto;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81/%E6%95%B0%E6%8D%AE%E8%B5%84%E4%BA%A7.png" alt="" />
				<img style="width: 40vw;height: auto;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81/%E6%95%B0%E6%8D%AE%E8%B5%84%E4%BA%A72.png" alt="" />
			</div>
			
			<div class="title" style="margin-top: 30px;color: rgb(177 108 111);">天空地一体化 赋能智慧农业</div>
			<img style="width: 50vw;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81/%E4%BA%A7%E5%93%81%E6%9E%B6%E6%9E%84.png" alt="" />
			
			
			<div class="title" style="margin-top: 30px;margin-bottom: 5px;color: rgb(101 127 75);">数字农业</div>
			<div class="title-desc">用数字赋能产业  让数据驱动经济</div>
			<div class="flex justc">
				<img class="ny-image" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%95%B0%E5%AD%97%E5%86%9C%E4%B8%9A/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A%E5%B9%B3%E5%8F%B0.png"  alt="" />
				<img class="ny-image2"  src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%95%B0%E5%AD%97%E5%86%9C%E4%B8%9A/%E6%BA%AF%E6%BA%90%E7%A0%81.png" alt="" />
			</div>
			<div class="flex justc">
				<img class="ny-image" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%95%B0%E5%AD%97%E5%86%9C%E4%B8%9A/%E5%8E%BF%E5%9F%9F%E5%B9%B3%E5%8F%B0.png" alt="" />
				<img class="ny-image2" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%95%B0%E5%AD%97%E5%86%9C%E4%B8%9A/%E5%86%9C%E4%B8%9A%E4%BA%A7%E4%B8%9A%E5%A4%A7%E8%84%91.png" alt="" />
			</div>
			<div class="flex justc">
				<img class="ny-image" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%95%B0%E5%AD%97%E5%86%9C%E4%B8%9A/%E6%95%B0%E5%AD%97%E5%86%9C%E5%9C%BA.png" alt="" />
				<img class="ny-image2"  src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%95%B0%E5%AD%97%E5%86%9C%E4%B8%9A/%E6%B0%B4%E8%82%A5%E4%B8%80%E4%BD%93%E5%8C%96.png" alt="" />
			</div>
			
			<div class="title" style="margin-top: 30px;margin-bottom: 5px;color: rgb(101 127 75);">数字乡村</div>
			<div class="title-desc">数字赋能 &nbsp;&nbsp;&nbsp;&nbsp;和美乡村</div>
			<div class="flex justc">
				<img class="ny-image" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%B9%A1%E6%9D%91/2.png" alt="" />
				<img class="ny-image2"  src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%B9%A1%E6%9D%91/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20251024180820_23_121.png" alt="" />
			</div>
			
			<img style="width: 70vw;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%95%B0%E5%AD%97%E5%86%9C%E4%B8%9A/%E5%8D%83%E5%B9%BF%E6%99%BA%E6%85%A7%E5%86%9C%E4%B8%9A%E6%9C%8D%E5%8A%A1%E4%BD%93%E7%B3%BB.png" alt="" />
		</div>
		<div class="flexCol alit">
				<!-- <h1 class="" v-if="cpShowIndex == 1">火锅产业要素交易平台</h1> -->
			<!-- <h1 class="" v-if="cpShowIndex == 2">夔州肉兔产业大脑</h1> -->
			<!-- <h3 class="" style="color: #837e83;">夔州肉兔产业大脑夔州肉兔产业大脑夔州肉兔产业大脑</h3> -->
			<alien-swiper v-if="cpShowIndex == 1" style="width: 100vw;"></alien-swiper>
			<alien-swiper2 v-if="cpShowIndex == 2" style="width: 100vw;"></alien-swiper2>
		</div>

		<div class="flex justc alit">
			<div class="flexCol alit" :class="cpShowIndex == 1 ? 'cpshow-check' : 'cpshow-defalut'"
				@click="cpShowIndex = 1">
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/5324adc4-a5af-418e-92d1-25b9602c110e.png"
					style="width: 200px;" alt="" />
				<div class="">火锅产业要素交易平台</div>
			</div>
			<div class="flexCol alit" :class="cpShowIndex == 2 ? 'cpshow-check' : 'cpshow-defalut'"
				@click="cpShowIndex = 2">
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/rabbit/1.jpg"
					style="width: 200px;" alt="" />
				<div class="">夔州肉兔产业大脑</div>
			</div>
		</div>

		<div class="flexCol alit" style="margin-top: 40px;">
			<!-- <div class="title">关于我们</div> -->
			<div class="commpany">
				<!-- <h1 style="margin: 80px 0 20px 30px;">重庆千广科技有限公司</h1>
				<p class="commpany-desc" style="border-top: 4px solid #eee;padding-top: 10px;">
					这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介这里是公司简介
				</p> -->
			</div>
			<div class="flex justb" style="width: 70vw;margin-bottom: 30px;">
				<div class="" style="width: 45%;height: 90vh;position: relative;">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%99%BA%E8%83%BD%E8%A3%85%E5%A4%87/%E6%B0%B4%E8%82%A5%E6%9C%BA.png"
						style="width: 100%;height: 100%;" alt="" />
					<div class="zh-desc">
						<h2 class="">千广智慧农业</h2>
						<h4 class="" style="margin-top: -10px;">智能水肥一体机</h4>
					</div>
				</div>
				<div class="flexCol justb" style="width: 51%;height: 90vh;">
					<div class="" style="position: relative;height: 49%;">
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%99%BA%E8%83%BD%E8%A3%85%E5%A4%87/5.png"
							alt="" style="width: 100%;height: 100%;" />
						<div class="zh-desc">
							<h2 class="">千广智慧农业</h2>
							<h4 class="" style="margin-top: -10px;">4G/LoraWan智能灌溉水阀</h4>
						</div>
					</div>
					<div class="" style="position: relative;height: 49%;">
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%99%BA%E8%83%BD%E8%A3%85%E5%A4%87/3.png"
							alt="" style="width: 100%;height: 100%;" />
						<div class="zh-desc">
							<h2 class="">千广智慧农业</h2>
							<h4 class="" style="margin-top: -10px;">4G/LoraWan智能灌溉水阀</h4>
						</div>
					</div>

				</div>
			</div>

			<!-- <div class="flex justb" style="width: 70vw;margin-bottom: 30px;">
				<div class="" style="width: 24.5%;position: relative;">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/sunshine.jpg"
						style="width: 100%;" alt="" />
					<div class="flexCol justc alit zh-desc2">
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/sunshine-icon.png"
							style="height: 22px;" alt="" />
						<div class="" style="color: #fff;">阳光</div>
					</div>
				</div>
				<div class="" style="width: 24.5%;position: relative;">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/air.jpg"
						style="width: 100%;" alt="" />
					<div class="flexCol justc alit zh-desc2">
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/air-icon.png"
							style="height: 22px;" alt="" />
						<div class="" style="color: #fff;">空气</div>
					</div>
				</div>
				<div class="" style="width: 24.5%;position: relative;">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/water.jpg"
						style="width: 100%;" alt="" />
					<div class="flexCol justc alit zh-desc2">
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/water-icon.png"
							style="height: 22px;" alt="" />
						<div class="" style="color: #fff;">水</div>
					</div>
				</div>
				<div class="" style="width: 24.5%;position: relative;">
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/soil.jpg"
						style="width: 100%;" alt="" />
					<div class="flexCol justc alit zh-desc2">
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/w8ri2Q.png"
							style="height: 22px;" alt="" />
						<div class="" style="color: #fff;">土壤</div>
					</div>
				</div>
			</div> -->

		</div>

	</div>
</template>
<script setup>
	import alienSwiper from '../components/certifySwiper/index.vue'
	import alienSwiper2 from '../components/certifySwiper/index2.vue'
	import homeTopSwiper from '../components/homeTopSwiper/index.vue'
	import {
		ref
	} from 'vue'

	const cpIndex = ref(1)
	const cpShowIndex = ref(1)
</script>
<style scoped lang="scss">
	.ny-image{
		width: 35%;
		margin-bottom: 10px;
	}
	.ny-image2{
		width: 35%;
		margin-bottom: 10px;
		margin-left: 20px;
	}
	.zh-desc2 {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		div{
			margin-top: 5px;
			font-size: 22px;
		}
	}

	.zh-desc {
		position: absolute;
		left: 30px;
		bottom: 20px;
		color: #fff;
	}

	.commpany {
		width: 70vw;
		height: 55vh;
		background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/1af9bffc3e2fb2be1b693167ada81ee4.png');
		background-size: 100% 100%;
		margin-bottom: 30px;

		.commpany-desc {
			width: 45vw;
			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			margin-left: 30px;
			line-height: 22px;
		}
	}

	.cpshow-check {
		opacity: 1;
		transform: scale(1.1);
		margin-right: 30px;
		cursor: pointer;

		div {
			font-size: 20px;
			font-weight: 900;
			margin-top: 5px;
		}
	}

	.cpshow-defalut {
		opacity: 0.6;
		margin-right: 30px;
		cursor: pointer;

		div {
			font-size: 20px;
			margin-top: 5px;
		}
	}

	.cpshow-defalut:hover {
		opacity: 1;
		animation: enlarge2 0.5s forwards;
	}

	@keyframes enlarge2 {
		from {
			transform: scale(1);
		}

		to {
			transform: scale(1.1);
		}
	}

	.cp-check {
		color: #3e83ac;
	}

	.cp {
		width: 20%;
		cursor: pointer;
		text-align: center;
		font-weight: 900;
		font-size: 20px;

		div {
			margin-top: 15px;
		}
	}

	.cp:hover {
		img {
			animation: enlarge 0.5s forwards;
		}
	}

	@keyframes enlarge {
		from {
			transform: scale(1);
		}

		to {
			transform: scale(1.3);
		}
	}


	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
	}
	
	.title-desc{
		text-align: center;
		font-weight: 900;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>